import { JsonObject } from 'json2typescript';
import { PortfolioanalysisPositionsInterface } from '../interfaces/portfolioanalysis-positions.interface';

@JsonObject('PortfolioanalysisPositions')
export class PortfolioanalysisPositions
  implements PortfolioanalysisPositionsInterface
{
  Alias?: string;
  Code?: string;
  Currency?: string;
  EndDate?: string;
  Id?: string;
  InitialDate?: string;
  IsGrouped?: boolean;
  Name?: string;
  PortfolioCode?: string;
  PortfolioType?: string;
  Positions?: Position[];
  SameCode?: any;
  TotalEndDate?: string;
  TotalInitialDate?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('Position')
export class Position {
  AssetClassId?: string;
  AssetClassName?: string;
  AssetCurrency?: string;
  AssetPrice?: number;
  AssetPriceDate?: string;
  AssetTypeId?: string;
  AssetTypeName?: string;
  Behaviour?: string;
  Code?: string;
  ContractCode?: string;
  CostValue?: number;
  Id?: string;
  Isin?: string;
  Name?: string;
  Nominal?: number;
  NumberOfShares?: number;
  ProductCode?: string;
  ProductGroupId?: string;
  ProductGroupName?: string;
  ProductLineId?: string;
  ProductLineName?: string;
  QuotationType?: string;
  RiskLevel?: string;
  TaxRegimeName?: any;
  UnrealizedGains?: number;
  UnrealizedGainsPercent?: number;
  Valuation?: number;
  ValuationCurrency?: string;
  Volatility?: number;
  Weight?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('GroupingReference')
export class GroupingReference {
  AssetClasses?: AssetClass[];
  AssetTypes?: AssetType[];
  Currencies?: Currency[];
  ProductGroups?: ProductGroup[];
  ProductLines?: ProductLine[];

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('ProductLine')
export class ProductLine {
  Id?: string;
  Name?: string;
  Order?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('ProductGroup')
export class ProductGroup {
  Id?: string;
  Name?: string;
  Order?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('CurrencyGroupingReference')
export class Currency {
  Id?: string;
  Name?: string;
  Order?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('AssetType')
export class AssetType {
  Id?: string;
  Name?: string;
  Order?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('AssetClass')
export class AssetClass {
  Id?: string;
  Name?: string;
  Order?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
